import script from "./SettingsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettingsModal.vue?vue&type=script&setup=true&lang=ts"

import "./SettingsModal.vue?vue&type=style&index=0&id=79006330&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79006330"]])

export default __exports__